type Ring = number[][];
type Polygon = Ring[];
type MultiPolygon = Polygon[];

interface GeoFeature {
  properties?: { name?: string };
  geometry?: {
    type: string;
    coordinates: Polygon | MultiPolygon;
  };
}

interface GeoCollection {
  type: string;
  features: GeoFeature[];
}

export interface ProvincePath {
  name: string;
  path: string;
}

const LON_MIN = 73;
const LAT_MAX = 54;

function project(lon: number, lat: number): [number, number] {
  return [lon - LON_MIN, LAT_MAX - lat];
}

function ringToPath(ring: Ring): string {
  if (!ring || ring.length < 3) return '';
  let d = '';
  for (let i = 0; i < ring.length; i += 1) {
    const [x, y] = project(ring[i][0], ring[i][1]);
    d += `${i === 0 ? 'M' : 'L'}${x.toFixed(3)} ${y.toFixed(3)}`;
  }
  return `${d}Z`;
}

function geometryToPath(geometry: GeoFeature['geometry']): string {
  if (!geometry) return '';
  const parts: string[] = [];
  if (geometry.type === 'Polygon') {
    for (const ring of geometry.coordinates as Polygon) {
      const p = ringToPath(ring);
      if (p) parts.push(p);
    }
  } else if (geometry.type === 'MultiPolygon') {
    for (const polygon of geometry.coordinates as MultiPolygon) {
      for (const ring of polygon) {
        const p = ringToPath(ring);
        if (p) parts.push(p);
      }
    }
  }
  return parts.join(' ');
}

export function convertGeoToProvinces(data: GeoCollection): ProvincePath[] {
  const result: ProvincePath[] = [];
  for (const feature of data.features) {
    const name = feature.properties?.name || '';
    if (name.includes('南海') || name.includes('诸岛')) continue;
    const path = geometryToPath(feature.geometry);
    if (path) result.push({ name, path });
  }
  return result;
}

export async function fetchChinaBoundary(): Promise<ProvincePath[]> {
  const res = await fetch('https://geo.datav.aliyun.com/areas_v3/bound/100000_full.json');
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }
  const data: GeoCollection = await res.json();
  return convertGeoToProvinces(data);
}